import React, { useState } from 'react';

// Components.
import { CardText } from 'reactstrap';
import EmailLoginForm from '../EmailLoginForm';
import ReservationForm from '../ReservationForm';

const formComponents = { EmailLoginForm, ReservationForm };

function RegistrationContent({ showAlert = () => null, closeModal = () => null }) {
  const [formKey, setFormKey] = useState('ReservationForm');

  const showRegistrationForm = () => setFormKey('ReservationForm');
  const showLoginForm = () => setFormKey('EmailLoginForm');

  const FormComponent = formComponents[formKey];

  return (
    <div className="py-3">
      <CardText className="fs-4 text-center fw-semibold text-secondary annie-use-your-telescope-regular mb-3" >
        Reserve your username to enter beta
      </CardText>
      
      <div className="p-4 mx-xl-5 rounded-3 surface-elevated">
        <FormComponent
          key={`auth-form-${formKey}`}
          showAlert={showAlert}
          closeModal={closeModal}
          isModalContent={true}
          showLoginForm={showLoginForm}
          showRegistrationForm={showRegistrationForm}
          className="form-shell mx-auto gap-3"
        />
      </div>
    </div>
  );
}

export default RegistrationContent;
